import {
  SUBSCRIBE_URL,
  MEMBER_CENTER,
} from '../constants/constants-urls';

export const linksSubscribe = [
  {
    label : "Digital access",
    link : SUBSCRIBE_URL + '/B5759/?p1=BGFooter',
  },
  {
    label : "Home delivery",
    link : SUBSCRIBE_URL + '/B3428/?p1=BGFooter',
  },
  {
    label : "Gift subscriptions",
    link : "https://manage.bostonglobe.com/GiftTheGlobe/LandingPage.html",
  }
];

export const linksAccount = [
  {
    label : "Manage my account",
    link : MEMBER_CENTER + '?p1=BGFooter',
  },
  {
    label : "Mobile customer service",
    link : "https://www.bostonglobe.com/bgcs",
  },
  {
    label : "Sign up for newsletters",
    link : "https://www.bostonglobe.com/newsletters?p1=BGFooter_Newsletters",
  }
];

export const linksContact = [
  {
    label : "Help",
    link : "https://customerservice.globe.com/hc/en-us?p1=BGFooter",
  },
  {
    label : "FAQs",
    link : "https://customerservice.globe.com/hc/en-us?p1=BGFooter",
  },
  {
    label : "Globe newsroom",
    link : "https://www.bostonglobe.com/tools/help/stafflist?p1=BGFooter",
  },
  {
    label : "Advertise",
    link : "https://www.bostonglobemedia.com/",
  },
  {
    label : "Order back issue",
    link : "https://manage.bostonglobe.com/Order/newspaper/Newspaper.aspx",
  }
];

export const linksSocial = [
  {
    label : "Facebook",
    link : "https://www.facebook.com/globe",
  },
  {
    label : "Twitter",
    link : "https://twitter.com/#!/BostonGlobe",
  },
  {
    label : "Google+",
    link : "https://plus.google.com/108227564341535363126/about",
  }
];

export const linksMore = [
  {
    label : "ePaper",
    link : "https://epaper.bostonglobe.com/launch.aspx?pbid=2c60291d-c20c-4780-9829-b3d9a12687cf",
  },
  {
    label : "News in education",
    link : "http://nieonline.com/bostonglobe/",
  },
  {
    label : "Archives",
    link : "https://www.bostonglobe.com/eom/SysConfig/WebPortal/BostonGlobe/Framework/regi/archive-login.jsp",
  },
  {
    label : "Privacy Policy",
    link : "https://www.bostonglobe.com/about/help/privacy-policy/?p1=BGFooter",
  },
  {
    label : "Terms of service",
    link : "https://www.bostonglobe.com/about/help/terms-service/?p1=BGFooter",
  },
  {
    label : "Terms of purchase",
    link : "https://www.bostonglobe.com/about/help/terms-purchase/?p1=BGFooter",
  },
  {
    label : "Work at Boston Globe Media",
    link : "https://www.bostonglobemedia.com/careers",
  }
];



// WEBPACK FOOTER //
// ./src/constants/constants-footer-links.js